"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const TrackComponent_1 = __importDefault(require("../../components/trackList/TrackComponent"));
class TrackPresenter {
    constructor(parentElement, trackData, playerModel, tracksModel, likeCallback, dropdownCallback) {
        this.parentElement = parentElement;
        this.trackData = trackData;
        this.playerModel = playerModel;
        this.tracksModel = tracksModel;
        this.likeCallback = likeCallback;
        this.dropdownCallback = dropdownCallback;
        this.trackComponent = new TrackComponent_1.default(this.trackData);
        this.render();
    }
    render() {
        this.trackComponent.addOnLikeListener(this.likeCallback);
        this.trackComponent.addOnDropdownListener(this.dropdownCallback);
        this.trackComponent.addOnClickListener(() => {
            if (!this.playerModel.isLoading) {
                this.playerModel.track = this.trackData;
                this.playerModel.originalTracks = this.tracksModel.all();
                this.playerModel.onTrackListChange();
                this.playerModel.onTrackChange();
            }
        });
        this.parentElement.append(this.trackComponent.getElement());
    }
}
exports.default = TrackPresenter;
